// Display labels for the quality values returned by the avatar models API.
// Falls back to `${value}p` for any quality not listed here.
export const QUALITY_LABELS: Record<number, string> = {
  480: '480p',
  720: '720p HD',
  1080: '1080p Full HD'
}
